/* eslint-disable */

<template>
  <div class="pageDiv">
    <v-card>
      <h2>Terms of Agreement</h2>

      <v-card-text>
        <br>
          Indemnification and Hold Harmless: Any Member, Guest or other person who, in any manner, makes use of or accepts the use of any web application, software, apparatus, appliance, facility, privilege or service whatsoever owned, leased, licensed to, or operated by the OKAGA or by any Host Facility, shall do so at his or her own risk. Members and their guests shall hold the OKAGA, any manager or operator of the Host Facility, their affiliates, their successors and assigns and their respective shareholders, partners, directors, officers, members, employees, representatives, and agents (collectively, the “Indemnified Parties”) harmless from any and all loss, cost, claim of injury, damage or liability sustained or incurred by him or her, resulting from the participation in OKAGA event or the use of Host Facility’s property, arising out of or incident to membership in the OKAGA and/or from any act or omission of any of the Indemnified Parties, unless caused by the gross negligence or willful misconduct of any of the Indemnified Parties. Any Member shall have, shall owe and shall observe the same obligation to the Indemnified Parties hereunder in respect to any such loss, cost, claim, injury, damage or liability sustained or incurred by any guest or family member guest.
          <br><br>

          Assumption of Risks: I am aware that participating in the activities and sports, without limitation, offered by or associated with OKAGA, exposes me to many inherent risks, dangers and hazards. By engaging in any activities offered by or associated with OKAGA, I freely accept and fully assume all inherent risks, dangers and hazards and the possibility of personal injury, death, property damage or loss resulting there from.
          <br><br>
          
          <span class="label16">RELEASE OF LIABILITY WAIVER OF CLAIMS & INDEMNITY AGREEMENT:</span>
          <br><br>
          
          <b>
            In consideration of OKAGA permitting me to participate in its activities and sports, permitting me to the use of its equipment and permitting me the use of its facilities, I hereby agree as follows:
          </b>

          <br><br>

          <ul class="ulNumber">
            <li>
              TO WAIVE ANY AND ALL CLAIMS that I have or may in the future have against OKAGA, and its directors, officers, employees, agents, representatives, assigns and successors.
            </li>
            <li>
              TO RELEASE OKAGA, and its directors, officers, employees, agents, representatives, assigns and successors from any and all liability for any loss, damage, injury or expense that I may suffer or that my next of kin may suffer, as a result of my participation in activities and sports offered by OKAGA, due to any cause whatsoever INCLUDING NEGLIGENCE, BREACH OF CONTRACT, BREACH OF STATUTORY DUTY OF CARE, AND/OR BREACH OF THE OCCUPIER'S LIABILITY ACT, R.S.A. 2000, C. O-4, ON THE PART OF OKAGA and its directors, officers, employees, agents, representatives, assigns and successors.
            </li>
            <li>
              TO HOLD HARMLESS AND INDEMNIFY OKAGA, and directors, officers, employees, agents, representatives, assigns and successors from any and all liability for any property damage or personal injury to any third party, resulting from my activities and my participation in the activities offered by or associated with OKAGA. That this Agreement shall be effecting and binding upon any heirs, next of kin, executors, administrators and assigns in the event of my death.
              <br><br>
              I understand that if it is reported by the golf course or an opponent, that I have behaved in an unsporting manner or have not played by the rules, that I could be suspended or ejected from the league, with no refund.
            </li>
            <li>
              BY PARTICIPATING IN A OKAGA EVENT, I ACCEPT THE ABOVE STATED TERMS <br><br>
          
              Membership, or registration as a guest for entry into any OKAGA event, includes an express waiver and consent to the use of each Member’s and/or competitor’s name, image and/or likeness by Oklahoma Asian Golf Association, it’s subsidiaries and/or assigns, for purposes of promoting, marketing, reporting, or otherwise advertising the OKAGA mission, its events, chapters, website, etc. Said name, image, likeness may be used in all forms of media, including but not limited to the club’s website, social media channels, digital marketing, print marketing materials, etc. By joining the OKAGA or registering for any OKAGA event, each player expressly waives any right to compensation or control of the use of their name, image, or likeness by OKAGA, its subsidiaries or assigns.
            </li>
          </ul>
        
      </v-card-text>

    </v-card>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        done: ''
      }
    }
  }
</script>

<style scoped>
  .main-card {
    padding-top: 30px;
    margin-top: 10px !important;
  }


  @media (min-width: 768px) {
  }
</style>